module.exports = __webpack_public_path__ + "static/media/clubs-jack.28092ce0.png";